/** @jsxImportSource @emotion/react */

import * as styles from './Divider.styles';

type DividerType = 'LINE_80_10' | 'LINE_100_10' | 'LINE_100_10_CARD' | 'SPACE' | 'SPACE_LINE';
export const DividerTypes: DividerType[] = [
  'LINE_80_10',
  'LINE_100_10',
  'LINE_100_10_CARD',
  'SPACE',
  'SPACE_LINE',
];

export interface DividerProps {
  className?: string;
  type: 'LINE_80_10' | 'LINE_100_10' | 'LINE_100_10_CARD' | 'SPACE' | 'SPACE_LINE';
}

function Divider({ className, type }: DividerProps) {
  return <hr className={className} css={styles.wrapper(type)} />;
}

export default Divider;
